var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from './../../../../shared/models/filter-data';
var TipusMatriculaFilter = /** @class */ (function (_super) {
    __extends(TipusMatriculaFilter, _super);
    function TipusMatriculaFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.descripcio = '';
        _this.denunciaZB = null;
        _this.denunciaPOL = null;
        _this.guardarLOG = null;
        _this.reincidents = null;
        _this.codInsti = '';
        _this.codi = '';
        _this.generarAlarma = null;
        _this.labels['descripcio'] = _this.i18n('Descripció');
        _this.labels['denunciaZB'] = _this.i18n('Zona blava');
        _this.labels['denunciaPOL'] = _this.i18n('Policia');
        _this.labels['reincidents'] = _this.i18n('Reincidents');
        _this.labels['guardarLOG'] = _this.i18n('Guarda LOG');
        _this.labels['generarAlarma'] = _this.i18n('Generar Alarma');
        return _this;
    }
    return TipusMatriculaFilter;
}(FilterData));
export { TipusMatriculaFilter };
